module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"categories":{"banking":"Banking & Personal Finance","broadband":"Broadband","insurance":"Insurance"},"head":"Winner at the 2021 bonkers.ie awards"}}')
  delete Component.options._Ctor
}
